import { CareOpportunity, ClinicalDashboard } from "pages/clinical";

const clinicalRoutes = [
  {
    path: "/clinical-care-dashboard",
    isExact: true,
    component: ClinicalDashboard,
  },

  {
    path: "/care-opportunity",
    isExact: false,
    component: CareOpportunity,
  },
];

export default clinicalRoutes;
